export default __webpack_public_path__ + "static/media/pie_chart.cf2581ee.png";